import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const IncludedSeats = ({
  // includedTotalSeats,
  includedSalesSeats = 0,
  includedServiceSeats = 0,
  includedCommerceSeats = 0,
  includedCoreSeats = 0
}) => {
  const hasMixedSeats = includedCoreSeats > 0 && (includedSalesSeats > 0 || includedServiceSeats > 0 || includedCommerceSeats > 0);
  const includedTotalSeats = includedCoreSeats + includedSalesSeats + includedServiceSeats + includedCommerceSeats;
  if (hasMixedSeats) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "seatsComponents.includedSeats.mixed",
      options: {
        count: includedTotalSeats
      }
    });
  }
  if (includedSalesSeats > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "seatsComponents.includedSeats.sales",
      options: {
        count: includedSalesSeats
      }
    });
  }
  if (includedServiceSeats > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "seatsComponents.includedSeats.service",
      options: {
        count: includedServiceSeats
      }
    });
  }
  if (includedCoreSeats > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "seatsComponents.includedSeats.core",
      options: {
        count: includedCoreSeats
      }
    });
  }
  return null;
};